import Section from './Section.vue'

export const spinLuckModule = {
  type: 1,
  component: Section,
  reset(localForm, ctx) {
    const { buildDefaultTiers, ruleFlags, ruleValues } = ctx
    localForm.vips = []
    localForm.tiers = buildDefaultTiers()
    ruleFlags.login = false
    ruleFlags.bet = false
    ruleFlags.payin = false
    ruleFlags.level = false
    localForm.spinRuleAtLeastOne = 0

    ruleValues.daily_login_bonus_count = undefined
    ruleValues.daily_bet_amount = undefined
    ruleValues.daily_bet_amount_ticket_reward = undefined
    ruleValues.daily_total_payin_amount = undefined
    ruleValues.daily_total_payin_amount_ticket_reward = undefined
    ruleValues.level_up_bonus_count = undefined
  },
  fillFromActivity(localForm, raw, ctx) {
    const { TIER_COUNT, centsToYuanNumber, normalizeTierForForm, createEmptyTier, ruleFlags, ruleValues } = ctx
    const cfg = raw.config || {}
    const rule = cfg.rule && typeof cfg.rule === 'object' ? cfg.rule : {}

    if (rule.daily_login_bonus_count != null && Number(rule.daily_login_bonus_count) > 0) {
      ruleFlags.login = true
      ruleValues.daily_login_bonus_count = Number(rule.daily_login_bonus_count)
    }
    if (rule.daily_bet_amount != null && Number(rule.daily_bet_amount) > 0) {
      ruleFlags.bet = true
      ruleValues.daily_bet_amount = centsToYuanNumber(rule.daily_bet_amount)
      ruleValues.daily_bet_amount_ticket_reward = Number(rule.daily_bet_amount_ticket_reward) || 0
    }
    if (rule.daily_total_payin_amount != null && Number(rule.daily_total_payin_amount) > 0) {
      ruleFlags.payin = true
      ruleValues.daily_total_payin_amount = centsToYuanNumber(rule.daily_total_payin_amount)
      ruleValues.daily_total_payin_amount_ticket_reward = Number(rule.daily_total_payin_amount_ticket_reward) || 0
    }
    if (rule.level_up_bonus_count != null && Number(rule.level_up_bonus_count) > 0) {
      ruleFlags.level = true
      ruleValues.level_up_bonus_count = Number(rule.level_up_bonus_count)
    }

    if (Array.isArray(cfg.vips)) {
      localForm.vips = cfg.vips.map(v => Number(v)).filter(v => Number.isFinite(v))
    }
    if (Array.isArray(cfg.tiers) && cfg.tiers.length > 0) {
      const normalized = cfg.tiers.slice(0, TIER_COUNT).map(normalizeTierForForm)
      while (normalized.length < TIER_COUNT) normalized.push(createEmptyTier())
      localForm.tiers = normalized
    }
  },
  validate(localForm, ctx) {
    const { Message, parseTierWeight, BONUS_GOLD, BONUS_NONE } = ctx
    let hasEmptyReward = false
    for (let i = 0; i < localForm.tiers.length; i += 1) {
      const t = localForm.tiers[i]
      const row = i + 1
      if (t.bonus_type == null || t.bonus_type === '') {
        Message.error(`奖池第${row}行请选择奖励类型`)
        return false
      }
      if (t.bonus_type === BONUS_NONE) hasEmptyReward = true

      if (t.bonus_type === BONUS_GOLD) {
        const y = t.reward_count_yuan
        if (y == null || y === '' || Number(y) <= 0) {
          Message.error(`奖池第${row}行请输入金币数量`)
          return false
        }
        const m = Number(t.multiple)
        if (!Number.isFinite(m) || m <= 0) {
          Message.error(`奖池第${row}行打码倍数须大于0`)
          return false
        }
      }
    }
    if (!hasEmptyReward) {
      Message.error('转盘奖池至少设置一个空奖励')
      return false
    }
    const sumW = localForm.tiers.reduce((acc, t) => acc + parseTierWeight(t.weight), 0)
    if (sumW <= 0) {
      Message.error('请至少为一项奖池填写大于0的概率权重')
      return false
    }
    return true
  },
  buildPayload(localForm, ctx) {
    const { yuanToCents, buildRulePayload, BONUS_GOLD, BONUS_NONE } = ctx
    return {
      spin_luck_config: {
        rule: buildRulePayload(),
        vips: [...localForm.vips].sort((a, b) => a - b),
        tiers: localForm.tiers.map((t, idx) => {
          return {
            index: idx + 1,
            bonus_type: t.bonus_type == null || t.bonus_type === '' ? BONUS_NONE : t.bonus_type,
            reward_count: t.bonus_type === BONUS_GOLD ? yuanToCents(t.reward_count_yuan) : 0,
            multiple: t.bonus_type === BONUS_GOLD ? Number(t.multiple) || 0 : 0,
            available_num: t.total_unlimited ? -1 : Number(t.available_num),
            weight: Number(t.weight) || 0,
          }
        }),
      },
    }
  },
}

